import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import Card from '../Card';
import styles from './styles.module.scss';
import ModalLoading from '../../../../../components/ModalLoading';
import services from '../../../../../services';

const Participantes = ({participantes, setParticipantes, parceiro}) => {
    const history = useHistory()
    const [modalLoading, setModalLoading] = useState(false);
    const [permiteAlterarParticipante, setPermiteAlterarParticipante] = useState(services.storage.getClaimValues("Participantes", "Alterar"));
    const [permiteVisualizarParticipante, setPermiteVisualizarParticipante] = useState(services.storage.getClaimValues("Participantes", "Visualizar"));
    const [permiteAdicionarParticipante, setPermiteAdicionarParticipante] = useState(services.storage.getClaimValues("Participantes", "Cadastrar"));
    
    const addParticipante = () => {
        history.push(`/participantes?parceiro=${parceiro}&acao=I`)
    }


    return (
        <div className={styles.wrapper}>
            <div className={` ${styles.content}`}>
                <div className={` ${styles.card}`}>
                    <div className={styles.subTitle}>
                        Participantes
                    </div>
                    {
                        (permiteAdicionarParticipante) && (
                            <div className={styles.buttonWrapper}>
                                <button className={`btnInvert ${styles.btAdd}`} onClick={addParticipante}>
                                    Adicionar Participante
                                </button>
                            </div>
                        )
                    }
                    <div className={styles.acoesWrapper}>
                        {
                            Boolean(participantes.length) ?
                                participantes.map(
                                    (usuario) => {return (
                                    <Card usuario={usuario} 
                                        key={usuario.id} 
                                        parceiro={parceiro}
                                        status={usuario.status}
                                        permiteAlterar={permiteAlterarParticipante}
                                        permiteVisualizar={permiteVisualizarParticipante}/>)}
                                )
                            :
                            (
                                !modalLoading &&
                                (
                                    <div>
                                        Nenhum registro encontrado
                                    </div>
                                )
                            )
                        }
                    </div>
                    <ModalLoading
                        open={modalLoading} 
                        size="lg"
                    />
                </div>
            </div>
        </div>
    );
  
}

export default Participantes;